import {Flex} from "../Flex";
import styled from "styled-components";

export interface IRowProps {
  header?: boolean;
}

export const Row = styled(Flex)<IRowProps>`
`;
